export default __webpack_public_path__ + "static/media/Ficha_frijol_ZH.0b8c2cb4.png";